<template>
  <div class="content">
    <div class="main_content">
      <div class="content_left">
        <div v-for="item in cateList" :key="item.id" class="left_section">
          <div
            class="left_title"
            :class="{ left_title_active: item.id == firstActive }"
            @click.stop="titleClick(item, 'study')"
          >
            <div class="left_title_icon">
              <div
                v-show="item.id == firstActive"
                class="left_title_icon_tri_on"
              ></div>
              <div
                v-show="item.id != firstActive"
                class="left_title_icon_tri_off"
              ></div>
            </div>
            <div class="left_title_text">{{ item.title }}</div>
          </div>
          <div v-show="item.id == firstActive" class="left_tabs">
            <div
              v-for="(secItem, secIndex) in item.child"
              :key="secIndex"
              @click.stop="navChange(secItem.id)"
              class="left_nav"
            >
              <div
                class="nav_content"
                :class="{ navActive: secondActive == secItem.id }"
              >
                <div class="nav_text">{{ secItem.title }}</div>
                <div class="nav_icon" v-show="secondActive == secItem.id">
                  ∨
                </div>
                <div class="nav_icon" v-show="secondActive != secItem.id">
                  >
                </div>
              </div>
              <div class="nav_slide">
                <div class="slide_nav" v-show="secondActive == secItem.id">
                  <div class="slide_content">
                    <div
                      class="slide_title"
                      :class="{ titleActive: thirdActive == 'all' }"
                      @click.stop="chooseChange('all', secItem.id)"
                    >
                      本课程所有习题
                    </div>
                  </div>
                  <div
                    class="slide_content"
                    v-for="(thirdItem, thirdIndex) in secItem.child"
                    :key="thirdIndex"
                  >
                    <div
                      class="slide_title"
                      :class="{ titleActive: thirdActive == thirdItem.id }"
                      @click.stop="chooseChange(thirdItem.id, thirdItem.id)"
                    >
                      {{ thirdItem.title }}
                    </div>
                    <div
                      v-show="thirdActive == thirdItem.id"
                      class="slide_detail"
                    >
                      <div
                        class="detail_text"
                        @click.stop="typeChange('0')"
                        :class="{ typeActive: fourthActive == '0' }"
                      >
                        • 本课程所有习题
                      </div>
                      <div
                        class="detail_text"
                        @click.stop="typeChange('1')"
                        :class="{ typeActive: fourthActive == '1' }"
                      >
                        • 单选练习
                      </div>
                      <div
                        class="detail_text"
                        @click.stop="typeChange('2')"
                        :class="{ typeActive: fourthActive == '2' }"
                      >
                        • 多选练习
                      </div>
                      <div
                        class="detail_text"
                        @click.stop="typeChange('3')"
                        :class="{ typeActive: fourthActive == '3' }"
                      >
                        • 判断练习
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="item in paperList" :key="item.id" class="left_section">
          <div
            class="left_title"
            :class="{ left_title_active: item.id == firstActive }"
            @click="titleClick(item, 'exam')"
          >
            <div class="left_title_icon">
              <!-- <div v-show="item.id == firstActive" class="left_title_icon_tri_on"></div> -->
              <div class="left_title_icon_tri_off"></div>
            </div>
            <div class="left_title_text">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="content_right">
        <div class="right_top" v-show="!questionDetail.type">暂无题目</div>

        <!-- 考试题目 -->
        <div
          class="right_top"
          v-show="questionDetail.type && questionType == 'exam'"
        >
          <div class="topic_type">
            <div class="type_text">{{ questionDetail.type_name }}</div>
            <div class="type_line"></div>
          </div>
          <div class="topic_finish" v-show="hasexamResult">
            <div class="finish_result">
              得{{ scoreMsg.score }}分。共{{ examquestionTotal }}题，答对{{
                examquestionTotal - examquestionFalse
              }}题，答错{{ examquestionFalse }}题
            </div>
            <router-link :to="{ path: '/mistake' }" class="finish_btn"
              >错题重做</router-link
            >
          </div>
          <div class="topic_content" v-show="!hasexamResult">
            <div class="topic_title">
              <p>{{ questionNum }}、</p>
              <p v-html="questionDetail.title">{{ questionDetail.title }}</p>
            </div>
            <div class="topic_answers" v-show="questionDetail.type == 1">
              <div
                class="answer_content"
                v-for="(item, index) in questionList[questionNum - 1].options"
                :key="index"
                @click="checkRadio(index)"
              >
                <div
                  class="answer_icon"
                  :class="{ answerChecked: item.isChecked }"
                ></div>
                <div class="answer_text">
                  {{ letterList[index] }}.{{ item.options }}
                </div>
              </div>
            </div>
            <div class="topic_answers" v-show="questionDetail.type == 2">
              <div
                class="answer_content"
                v-for="(item, index) in questionList[questionNum - 1].options"
                :key="index"
                @click="checkBox(index)"
              >
                <div
                  class="answer_icon"
                  :class="{ answerChecked: item.isChecked }"
                ></div>
                <div class="answer_text">
                  {{ letterList[index] }}.{{ item.options }}
                </div>
              </div>
            </div>
            <div class="topic_answers" v-show="questionDetail.type == 3">
              <div
                class="answer_content"
                v-for="(item, index) in questionList[questionNum - 1].options1"
                :key="index"
                @click="checkJudje(index)"
              >
                <div
                  class="answer_icon"
                  :class="{ answerChecked: index == judjeIndex }"
                ></div>
                <div class="answer_text">{{ item }}</div>
              </div>
            </div>
          </div>

          <!-- 考试答案解析 -->
          <div class="jiexi-box" v-show="show_jiexi">
            <div class="topic_result">
              <div class="result_your">
                【你的答案】<span>{{ jiexiObj.my_danan }}</span>
              </div>
              <div class="result_true">
                【正确答案】{{ jiexiObj.timu_daan }}
              </div>
              <div class="result_analysis">
                <p>【答案解析】</p>
                <p v-html="jiexiObj.text"></p>
              </div>
            </div>
          </div>

          <div class="topic_operation" v-show="!hasexamResult">
            <div class="operation_left">
              <div class="operation_btn pre_topic" @click="prevQuestion">
                上一题
              </div>
              <div
                v-show="questionNum != questionTotal"
                @click="nextQuestion"
                class="operation_btn next_topic"
              >
                下一题
              </div>
            </div>
            <div class="operation_right">
              <div
                v-show="questionNum == questionTotal"
                @click="submitAnswer"
                class="operation_btn next_topic"
              >
                提交
              </div>

              <div
                class="operation_btn operation_topic"
                v-show="!hasCollectFlag"
                @click="collectTopic"
              >
                收藏
              </div>
              <div
                class="operation_btn next_topic"
                v-show="hasCollectFlag"
                @click="collectTopic"
              >
                已收藏
              </div>
              <div
                class="operation_btn next_topic"
                v-show="sumitExam"
                @click="onClick_checkAnwser"
              >
                查看答案
              </div>
            </div>
          </div>
        </div>
        <!-- 考试答案结束 -->

        <!-- 右侧答题区域 -->
        <div
          class="right_top"
          v-show="questionDetail.type && questionType == 'study'"
        >
          <div class="topic_type">
            <div class="type_text">{{ questionDetail.type_name }}</div>
            <div class="type_line"></div>
          </div>
          <div class="topic_content">
            <!-- 问题标题 -->
            <div class="topic_title">
              <p>{{ questionNum }}、</p>
              <p v-html="questionDetail.title">{{ questionDetail.title }}</p>
            </div>

            <!-- 单选题 -->
            <div class="topic_answers" v-show="questionDetail.type == 1">
              <div
                class="answer_content"
                v-for="(item, index) in questionList[questionNum - 1].options"
                :key="index"
                @click="checkRadio(index)"
              >
                <div
                  class="answer_icon"
                  :class="{ answerChecked: item.isChecked }"
                ></div>
                <div class="answer_text">
                  {{ letterList[index] }}.{{ item.options }}
                </div>
              </div>
            </div>
            <!-- 多选 -->
            <div class="topic_answers" v-show="questionDetail.type == 2">
              <div
                class="answer_content"
                v-for="(item, index) in questionList[questionNum - 1].options"
                :key="index"
                @click="checkBox(index)"
              >
                <template v-if="currMode == 'exam'">
                  <div
                    class="answer_icon"
                    :class="{ answerChecked: item.isChecked }"
                  ></div>
                </template>
                <template v-if="currMode == 'study'">
                  <div
                    class="answer_icon"
                    :class="{
                      answerChecked:
                        arr_select &&
                        arr_select[questionNum - 1] &&
                        arr_select[questionNum - 1].includes(item.options),
                    }"
                  ></div>
                </template>

                <div class="answer_text">
                  {{ letterList[index] }}.{{ item.options }}
                </div>
              </div>
            </div>

            <!-- 判断 -->
            <div class="topic_answers" v-show="questionDetail.type == 3">
              <div
                class="answer_content"
                v-for="(item, index) in questionList[questionNum - 1].options"
                :key="index"
                @click="checkJudje(index)"
              >
                <div
                  class="answer_icon"
                  :class="{
                    answerChecked: arr_select[questionNum - 1] == item,
                  }"
                ></div>
                <div class="answer_text">{{ item }}</div>
              </div>
            </div>
          </div>
          <div class="topic_result" v-show="showAnswerFlag">
            <div class="result_your">
              【你的答案】<span>{{ questionResult.youser_answer }}</span>
            </div>
            <div class="result_true">
              【正确答案】{{ questionResult.right_answer }}
            </div>
            <div class="result_analysis">
              <p>【答案解析】</p>
              <p v-html="questionResult.analysis">
                {{ questionResult.analysis }}
              </p>
            </div>
          </div>
          <div class="topic_operation">
            <div class="operation_left">
              <div class="operation_btn pre_topic" @click="prevQuestion">
                上一题
              </div>
              <div
                v-if="questionNum == questionTotal"
                class="operation_btn next_topic"
              >
                完成
              </div>
              <div
                v-else
                @click="nextQuestion"
                class="operation_btn next_topic"
              >
                下一题
              </div>
            </div>
            <div class="operation_right">
              <div class="operation_btn operation_topic" @click="getAnswer">
                答案
              </div>
              <div
                class="operation_btn operation_topic"
                v-show="!hasCollectFlag"
                @click="collectTopic"
              >
                收藏
              </div>
              <div
                class="operation_btn next_topic"
                v-show="hasCollectFlag"
                @click="collectTopic"
              >
                已收藏
              </div>
            </div>
          </div>
        </div>

        <!-- 做题  新增做题记录 逻辑 -->
        <div class="right_bottom" v-if="questionList.length > 1">
          <div class="topic_number" v-if="questionType == 'study'">
            <div
              class="topic_index"
              v-for="(item, index) in questionList"
              :key="index"
              @click="gotoQuestion(index)"
              :class="
                item.hasChosenFlag || item.judgeanswerText
                  ? item.correctFlag
                    ? 'right'
                    : 'error'
                  : ''
              "
            >
              {{ index + 1 }}
            </div>
          </div>

          <!-- 考试 -->
          <div class="topic_number" v-else-if="questionType == 'exam'">
            <!-- 没有提交考试答案 -->
            <template v-if="!sumitExam">
              <div
                class="topic_index"
                v-for="(item, index) in questionList"
                :key="index"
                @click="gotoQuestion(index)"
                :class="{
                  finishText: item.hasChosenFlag || item.judgeanswerText,
                }"
              >
                {{ index + 1 }}
              </div>
            </template>

            <!-- 已经提交考试问卷 -->
            <template v-else>
              <div
                class="topic_index"
                v-for="(item, index) in list_shijuan"
                :key="index"
                @click="gotoQuestion(index)"
                :class="item.mistake ? 'cuowu' : 'zhengque'"
              >
                {{ index + 1 }}
              </div>
            </template>
          </div>
          <div
            class="submit_topic"
            v-if="!sumitExam && questionType == 'exam' && !hasexamResult"
            @click="submitAnswer"
          >
            交<br />卷
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, hideLoading } from "@/request/loading.js";
import format from "@/common/util.js";
import { getPaperList } from "@/api/paper.js";
import { getPaperCate } from "@/api/paper.js";
import { addPaper } from "@/api/paper.js";
import { getPaperDetail } from "@/api/paper.js";
import { hasCollect } from "@/api/paper.js";
import { addCollection } from "@/api/paper.js";
import { deleteCollection } from "@/api/paper.js";
import { submitPaper } from "@/api/paper.js";
import { getScore } from "@/api/paper.js";
import { getScoreDetail } from "@/api/paper.js";
import { getQuestionListByCate } from "@/api/paper.js";
import { getQuestionResult } from "@/api/paper.js";

import { questionRecord } from "@/api/paper.js";

export default {
  name: "home",
  data() {
    return {
      
      show_jiexi: false, //是否展示考试答案解析
      list_shijuan: [], //试卷列表
      sumitExam: false, //是否已经提交考试问卷

      currMode: "", //模式  考试exam  学习 study
      //正确答案的数据
      // type =  1 单选  2 多选  3判断   4简答   5填空
      arr_true: [], //正确答案的结果
      arr_select: [], //做题结果
      arr_result: [], //是否正确的结果 1,正确 2,错误 null 没有记录
      mySelectAnswer: "", //当前问题 我选择的答案
      curr_cate_id: "", //当前答题对应的三级分类id

      uniqid: "",

      firstActive: "",
      secondActive: "",
      thirdActive: "",
      fourthActive: "",
      paperRequestData: {
        token: "",
        category_id: "",
        limit: 100,
        page: 1,
        is_exercise: 0,
      },
      paperList: [],
      cateRequestData: {
        token: "",
      },
      cateList: [],
      addRequestData: {
        token: "",
        user_id: "",
        paper_id: "",
        is_exeric: 0,
      },
      paperdetailRequestData: {
        token: "",
        paper_id: "",
      },
      questionList: [
        {
          options: [],
        },
      ],
      questionNum: 1,
      questionTotal: 0,
      questionDetail: {},
      submitRequestData: {
        token: "",
        user_id: "",
        paper_id: "",
        start_time: "",
        end_time: "",
        data: [],
      },
      scoreRequestData: {
        token: "",
        paper_id: "",
        user_id: "",
      },
      scoreMsg: {},
      questionRequestData: {
        token: "",
        exmain_key: "",
        user_id: "",
        paper_id: "",
        limit: 1000,
        offset: 0,
        question_id: "",
      },
      studyquestionRequestData: {
        token: "",
        cate: "",
        type: "",
      },
      hasexamResult: false,
      examquestionTotal: 0,
      examquestionFalse: 0,
      hasCollectData: {
        token: "",
        user_id: "",
        question_id: "",
      },
      hasCollectFlag: false,
      collectionRequestData: {
        token: "",
        user_id: "",
        question_id: "",
      },
      questionType: "",
      letterList: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      judjeIndex: 100,
      showAnswerFlag: false,
      resultRequestData: {
        token: "",
        question_id: "",
        answer: "",
      },
      questionResult: {},
    };
  },

  computed: {
    jiexiObj() {
      let obj = {};
      if (this.list_shijuan && this.list_shijuan.length) {
        let item = this.list_shijuan[this.questionNum -1];

        obj = {
          timu_daan: item.notes.right_answer,
          my_danan: item.notes.youser_answer,
          text: item.analysis,
        };
      }
      return obj;
    },
  },

  mounted() {
    let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.paperRequestData.token = window.localStorage.getItem("token");
    this.cateRequestData.token = window.localStorage.getItem("token");
    this.addRequestData.token = window.localStorage.getItem("token");
    this.paperdetailRequestData.token = window.localStorage.getItem("token");
    this.addRequestData.user_id = userInfo.user_id;
    this.hasCollectData.token = window.localStorage.getItem("token");
    this.hasCollectData.user_id = userInfo.user_id;
    this.collectionRequestData.token = window.localStorage.getItem("token");
    this.collectionRequestData.user_id = userInfo.user_id;
    this.submitRequestData.token = window.localStorage.getItem("token");
    this.submitRequestData.user_id = userInfo.user_id;
    this.questionRequestData.token = window.localStorage.getItem("token");
    this.questionRequestData.user_id = userInfo.user_id;
    this.scoreRequestData.token = window.localStorage.getItem("token");
    this.scoreRequestData.user_id = userInfo.user_id;
    this.studyquestionRequestData.token = window.localStorage.getItem("token");
    this.resultRequestData.token = window.localStorage.getItem("token");
    this.getPaper();
    this.getCate();
    if (this.$route.query.id) {
      let query_data = {
        id: this.$route.query.id,
        is_exercise: 0,
      };
      this.titleClick(query_data, "exam");
    }
  },
  methods: {
    //查看考试答案
    onClick_checkAnwser() {
      console.log("查看考试答案", this);
      console.log("查看考试答案", this.list_shijuan);
      let item = this.list_shijuan[this.questionNum];
      console.log("当前题目", { ...item });

      this.show_jiexi = !this.show_jiexi;
    },

    //提交问题记录
    submitQuestionRecord(data) {
      if (this.currMode == "exam") {
        return;
      }
      let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};

      data = {
        cate_id: this.curr_cate_id,
        user_id: userInfo.user_id,
        token: localStorage.getItem("token") || "",
        type: this.$route.query.type || "",
        ...data,
      };

      console.log("发送的数据", data);
      questionRecord(data).then((res) => {
        console.log("发送问题记录", res.data);
      });
    },

    //新增逻辑 如果使从未完成进入当前页面  需要显示页面
    setView() {
      if (this.$route.query.t1) {
        //题目的三级分类id
        let t1 = this.$route.query.t1; //一级分类
        let t2 = this.$route.query.t2; //二级分类
        let t3 = this.$route.query.t3; //三级分类
        let type = this.$route.query.type; //题目类型
        // let typeMap  = {
        //   '单选': 1,
        //   '多选': 2,
        //   '判断': 3,
        // };
        // let typeNum = typeMap[type] || 1;

        let item = this.cateList.find((v) => v.id == t1);
        let item2 = item.child.find((v) => v.id == t2);
        let item3 = item2.child.find((v) => v.id == t3);
        console.log("1级分类", { ...item });
        console.log("2级分类", { ...item2 });
        console.log("3级分类", { ...item3 });

        this.titleClick(item, "study"); //1级分类
        this.navChange(t2); //2级分类
        this.chooseChange(t3, t3); //3级分类

        this.typeChange(type);
        // this.getstudyQuestion();
      }
    },

    //考试
    getPaper() {
      let that = this;
      let data = this.paperRequestData;
      getPaperList(data).then((res) => {
        if (res.code == 0) {
          that.paperList = res.data.data;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //分类
    getCate() {
      let that = this;
      let data = this.cateRequestData;
      getPaperCate(data).then((res) => {
        console.log("获取分类信息", res);
        if (res.code == 0) {
          that.cateList = res.data;

          this.setView();
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //一级分类点击
    titleClick(item, type) {
      this.currMode = type;

      console.log("一级分类 item", { ...item });
      console.log("一级分类 type", type);

      console.log("伸缩展开");
      if (this.firstActive == item.id) {
        this.firstActive = "";
        return;
      }
      this.showAnswerFlag = false;
      this.questionNum = 1;
      this.firstActive = item.id;
      this.judjeIndex = 100;
      this.questionType = type;
      this.questionDetail = {};
      this.questionList = [
        {
          options: [],
        },
      ];
      if (type == "exam") {
        showLoading();
        this.hasexamResult = false;
        this.addRequestData.paper_id = item.id;
        this.paperdetailRequestData.paper_id = item.id;
        this.submitRequestData.paper_id = item.id;
        this.questionRequestData.paper_id = item.id;
        this.scoreRequestData.paper_id = item.id;
        this.addRequestData.is_exeric = item.is_exercise;
        this.addExam();
        this.getPaperDetailList();
        let start_time = new Date();
        this.submitRequestData.start_time = format.formatDateTime(start_time);
      }
    },
    //二级分类点击
    navChange(id) {
      console.log("二级分类 id", id);

      if (this.secondActive == id) {
        this.secondActive = "";
        // this.thirdActive = '';
        return;
      }
      this.secondActive = id;
    },
    //三级分类点击
    chooseChange(pid, id) {
      console.log("三级分类 pid", pid);
      console.log("三级分类 id", id);

      if (this.thirdActive == pid) {
        this.thirdActive = "";
        // this.thirdActive = '';
        return;
      } else {
        this.fourthActive = "";
      }

      this.thirdActive = pid;
      this.studyquestionRequestData.cate = id;
      this.studyquestionRequestData.type = 0;
      if (pid == "all") {
        showLoading();
        this.getstudyQuestion();
      }
    },
    //单选多选判断点击
    typeChange(type) {
      showLoading();
      this.fourthActive = type;
      this.studyquestionRequestData.type = type;
      this.getstudyQuestion();
    },
    //获取分类下所有练习题
    getstudyQuestion() {
      this.questionNum = 1;
      let that = this;
      let data = this.studyquestionRequestData;

      let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
      data = {
        ...data,
        user_id: userInfo.user_id,
      };

      console.log(data);

      this.curr_cate_id = data.cate;

      console.log("当前分类id", this.curr_cate_id);

      getQuestionListByCate(data).then((res) => {
        hideLoading();
        if (res.code == 0) {
          //新增逻辑  开始
          let questions = res.data.questions;
          let arr = questions.map(function (v) {
            if (v.type == 1 || v.type == 3) {
              return v.answer[0];
            } else if (v.type == 2) {
              return v.answer.join();
            }
          });
          this.arr_true = arr;
          console.log("所有的正确答案", arr);
          //新增逻辑  如果当前题目已经作答过，则需要回显
          this.arr_select = questions.map((v) => v.answers);
          console.log("作答情况 已选择", this.arr_select);

          //给选项赋值是否被选择
          questions.forEach((v) => {
            let answers = v.answers;
            if (answers) {
              //本题已作答
              if (v.type == 1) {
                //单选
                let opt = v.options.find((v) => v.options == answers);
                opt.isChecked = true;
              } else if (v.type == 2) {
                console.log("多选题");
              } else if (v.type == 3) {
                console.log("判断题");
              }
            }
          });
          //新增逻辑  结束

          //新增逻辑开始
          questions.forEach((v) => {
            //新增逻辑
            //给每条记录增加 字段
            //hasChosenFlag 是否被选择 true false
            //correctFlag 正确结果 1 0
            v.hasChosenFlag = v.answers ? true : false;

            let type = v.type;

            let currRet = ""; //当前题目的答案

            if (type == 1 || type == 3) {
              currRet = v.answer[0];
            } else if (v.type == 2) {
              currRet = v.answer.join();
            }

            let currSelect = v.answers; //当前题目所选择

            let ret = "";
            if (type == 1) {
              ret = currRet == currSelect ? 1 : 0;
            } else if (type == 2) {
              ret = currRet == currSelect ? 1 : 0;
            } else if (type == 3) {
              ret = currRet == currSelect ? 1 : 0;
            }

            v.correctFlag = ret;
          });
          //新增逻辑结束

          that.questionList = res.data.questions;
          that.questionTotal = res.data.questions.length;
          that.questionDetail = that.questionList[0];
          if (that.questionTotal == 0) {
            that.questionDetail = {};
            that.questionDetail.type = "";
            that.questionDetail.options = [];
            that.questionDetail.options1 = [];

            that.questionList.push(that.questionDetail);
            that.$message.error("该分类下暂无习题！");
          }
          that.getCollectionFlag();
        } else {
          that.$message.error(res.message);
        }

        console.log("初始化 questionList", this.questionList);
      });
    },
    //用户加入考试
    addExam() {
      let that = this;
      let data = this.addRequestData;
      addPaper(data).then((res) => {
        if (res.code == 0) {
          console.log(res);
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //获取考卷信息
    getPaperDetailList() {
      let that = this;
      let data = this.paperdetailRequestData;
      getPaperDetail(data).then((res) => {
        hideLoading();
        if (res.code == 0) {
          that.uniqid = res.data.uniqid;

          that.questionList = res.data.questions;
          that.questionTotal = res.data.questions.length;
          that.questionDetail = that.questionList[0];
          if (that.questionTotal == 0) {
            that.questionDetail = {};
            that.questionDetail.type = "";
            that.questionDetail.options = [];
            that.questionDetail.options1 = [];
            that.questionList.push(that.questionDetail);
          }
          that.getCollectionFlag();
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //上一题
    prevQuestion() {
      console.log("点击上一题");
      console.log("当前题号 this.questionNum", this.questionNum);

      this.showAnswerFlag = false;
      if (this.questionNum == 1) {
        this.$message.error("已经是第一题了~");
        return;
      }
      let index = this.questionNum - 2;
      this.questionNum = this.questionNum - 1;
      this.questionDetail = this.questionList[index];
      this.getCollectionFlag();
      this.judjeIndex = 100;
    },
    //下一题
    nextQuestion() {
      // this.arr_select[this.questionNum] = this.question_options[index];
      console.log("点击下一题");
      console.log("当前题号 this.questionNum", this.questionNum);

      let currIndex = this.questionNum - 1;

      //新增逻辑
      if (this.arr_select[currIndex]) {
        this.submitQuestionRecord({
          question_id: this.questionList[currIndex].question_id, //问题id
          // cate_id: this.$route.query.id,
          is_true:
            this.arr_true[currIndex] == this.arr_select[currIndex] ? 1 : 2, //1正确 2错误
          answer: this.arr_select[currIndex],
        });
      }

      this.showAnswerFlag = false;
      let index = this.questionNum;
      this.questionNum = this.questionNum + 1;
      this.questionDetail = this.questionList[index];
      this.getCollectionFlag();
      this.judjeIndex = 100;
    },
    //单选
    checkRadio(index) {
      let num = this.questionNum - 1;
      let options = this.questionDetail.options;
      options.forEach((item) => {
        item.isChecked = false;
      });
      this.questionList[num].options[index].isChecked = true;
      this.questionList[num].hasChosenFlag = true; //当前题目已作答
      this.judgequestionResult();
      this.$forceUpdate();

      console.log("单选 questionList", this.questionList);

      //新增逻辑
      //选择的答案
      this.arr_select[num] = this.questionList[num].options[index].options;
      console.log("已选择的答案", [...this.arr_select]);
      this.arr_select = [...this.arr_select];
    },
    //多选
    checkBox(index) {
      let num = this.questionNum - 1;
      let options = this.questionList[num].options;
      if (options[index].isChecked) {
        this.questionList[num].options[index].isChecked = false;
        this.questionList[num].hasChosenFlag = false;
      } else {
        this.questionList[num].options[index].isChecked = true;
      }
      options.forEach((item) => {
        if (item.isChecked) {
          this.questionList[num].hasChosenFlag = true; //当前题目已作答
        }
      });
      this.judgequestionResult();
      this.$forceUpdate();

      console.log("多选 questionList", this.questionList);

      //新增逻辑
      //选择的答案
      let selectText = this.questionList[num].options
        .filter((v) => v.isChecked)
        .map((v) => v.options)
        .join();

      console.log("本次选择的答案", selectText);

      this.arr_select[num] = selectText;
      console.log("多选 已选择的答案", [...this.arr_select]);
      this.arr_select = [...this.arr_select];
    },
    //判断
    checkJudje(index) {
      let num = this.questionNum - 1;
      this.judjeIndex = index;
      let question_options = "";
      if (this.questionType == "exam") {
        question_options = this.questionList[num].options1;
      } else {
        question_options = this.questionList[num].options;
      }
      this.questionList[num].judgeanswerText = question_options[index];
      console.log(this.questionList[num].judgeanswerText);
      this.questionList[num].hasChosenFlag = true; //当前题目已作答
      this.judgequestionResult();
      this.$forceUpdate();

      console.log("判断 questionList", this.questionList);

      //新增逻辑
      this.arr_select[this.questionNum - 1] = question_options[index];
      this.arr_select = [...this.arr_select];

      console.log("多选 已选择的答案", [...this.arr_select]);
    },
    //答题卡题号点击
    gotoQuestion(index) {
      this.showAnswerFlag = false;
      this.hasexamResult = false;
      this.questionNum = index + 1;
      this.questionDetail = this.questionList[index];
      this.getCollectionFlag();
    },
    // 判断用户是否收藏题
    getCollectionFlag() {
      let that = this;
      if (that.questionDetail) {
        that.hasCollectData.question_id = that.questionDetail.question_id;
        let data = this.hasCollectData;
        hasCollect(data).then((res) => {
          if (res.code == 0) {
            if (res.data.is_collect == 1) {
              that.hasCollectFlag = true;
            } else {
              that.hasCollectFlag = false;
            }
          } else {
            that.$message.error(res.message);
          }
        });
      }
    },
    //选完之后判断用户选择是否正确
    judgequestionResult() {
      let question_detail = this.questionDetail;
      if (question_detail.hasChosenFlag || question_detail.judgeanswerText) {
        this.showAnswerFlag = true;
        this.getAnswer();
      }
    },
    //答案
    getAnswer() {
      let that = this;
      let my_answer = [];
      let num = this.questionNum - 1;
      let options = this.questionDetail.options;
      if (this.questionDetail.type == 3) {
        console.log(this.questionList[num].judgeanswerText);
        if (this.questionList[num].judgeanswerText) {
          my_answer.push(this.questionList[num].judgeanswerText);
        }
      } else {
        options.forEach((item) => {
          if (item.isChecked) {
            my_answer.push(item.options);
          }
        });
      }
      if (my_answer.length == 0) {
        this.$message.error("请先作答再查看答案！");
      } else {
        this.showAnswerFlag = !this.showAnswerFlag;
        this.resultRequestData.question_id = this.questionDetail.question_id;
        this.resultRequestData.answer = my_answer.join(",");
        let data = this.resultRequestData;
        getQuestionResult(data).then((res) => {
          if (res.code == 0) {
            that.questionResult = res.data;
            that.questionList[num].correctFlag = that.questionResult.is_correct; //判断题目结果是否正确 1正确  0 错误
          } else {
            that.$message.error(res.message);
          }
        });
      }
    },
    //收藏
    collectTopic() {
      let that = this;
      this.collectionRequestData.question_id = this.questionDetail.question_id;
      let data = this.collectionRequestData;
      if (this.hasCollectFlag) {
        // 取消收藏
        deleteCollection(data).then((res) => {
          if (res.code == 0) {
            that.$message.success("取消收藏成功！");
            that.hasCollectFlag = false;
          } else {
            that.$message.error(res.message);
          }
        });
      } else {
        // 添加收藏
        addCollection(data).then((res) => {
          if (res.code == 0) {
            that.$message.success("收藏成功！");
            that.hasCollectFlag = true;
          } else {
            that.$message.error(res.message);
          }
        });
      }
    },
    // 交卷
    submitAnswer() {
      // let that = this;
      let question_list = this.questionList;
      let cansubmitFlag = true;
      let answerArr = [];
      question_list.forEach((item) => {
        let my_answer = [];
        let answer_con = {
          question_id: item.question_id,
          answer: "",
          type: item.type,
        };
        console.log(item);
        if (item.type == 3 && item.judgeanswerText) {
          answer_con.answer = item.judgeanswerText;
        } else {
          let options = item.options;
          options.forEach((optionItem) => {
            if (optionItem.isChecked) {
              my_answer.push(optionItem.options);
            }
          });
          answer_con.answer = my_answer.join(",");
        }
        answerArr.push(answer_con);
      });

      // for (const answerItem of answerArr) {
      //   if (answerItem.answer == "") {
      //     that.$message.error("检测到您还没有答完题，暂不能提交！");
      //     cansubmitFlag = false;
      //     return;
      //   }
      // }

      // answerArr.forEach(answerItem =>{
      // 	if(answerItem.answer == ''){
      // 		that.$message.error('检测到您还没有答完题，暂不能提交！');
      // 		cansubmitFlag = false
      // 		return
      // 	}
      // })
      if (cansubmitFlag) {
        this.submitRequestData.data = answerArr;
        this.sureSubmit();
      }
    },
    //确认交卷
    sureSubmit() {
      let that = this;
      let end_time = new Date();
      this.submitRequestData.end_time = format.formatDateTime(end_time);
      let data = this.submitRequestData;

      data = {
        ...data,
        uniqid: this.uniqid,
      };

      submitPaper(data).then((res) => {
        if (res.code == 0) {
          that.$message.success("提交成功！");
          console.log(res.data);
          that.questionRequestData.exmain_key = res.data.exmain_key;
          that.getexamScore();
          that.getexamResult();
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //获取考试分数
    getexamScore() {
      let that = this;
      let data = this.scoreRequestData;
      getScore(data).then((res) => {
        if (res.code == 0) {
          that.scoreMsg = res.data;
          console.log(that.scoreMsg);
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //获取考试结果
    getexamResult() {
      let that = this;
      let data = this.questionRequestData;
      this.examquestionTotal = 0;
      this.examquestionFalse = 0;
      getScoreDetail(data).then((res) => {
        if (res.code == 0) {
          this.list_shijuan = res.data;
          console.log("作答情况", res.data);

          console.log(res);
          let paperquestion_list = res.data;
          that.examquestionTotal = paperquestion_list.length;
          paperquestion_list.forEach((item) => {
            if (item.mistake == 1) {
              //是否答错
              that.examquestionFalse = that.examquestionFalse + 1;
            }
          });
          that.hasexamResult = true;

          this.sumitExam = true; //已经提交考试问卷
        } else {
          that.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: calc(100% - 210px);
  background-color: #f1f1f1;
  padding: 115px 0 15px;
}
.main_content {
  width: 1210px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: scroll;
  overflow-x: hidden;
}
.content_left {
  width: 298px;
  height: auto;
  min-height: calc(100% - 30px);
  border: 1px solid #d7d7d7;
  /* border-bottom: none; */
  background-color: #fefefe;
  display: flex;
  flex-direction: column;
}
.content_left .left_section {
  width: 298px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.content_left .left_title {
  width: 298px;
  height: 53px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
  z-index: 9;
  border-bottom: 1px solid #d7d7d7;
}
.content_left .left_title .left_title_icon {
  width: 24px;
  height: 24px;
  min-width: 24rpx;
  /* background-color: #a7051c; */
  background-color: #d7d7d7;
  border-radius: 50%;
  margin-left: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.content_left .left_title .left_title_icon .left_title_icon_tri_on {
  width: 10px;
  height: 6px;
  background-image: url("../assets/images/tri_on.png");
}
.content_left .left_title .left_title_icon .left_title_icon_tri_off {
  width: 6px;
  height: 10px;
  background-image: url("../assets/images/tri_off.png");
}
.content_left .left_title .left_title_text {
  width: 200px;
  font-size: 18px;
  /* color: #e3ffff; */
  color: #140303;
  margin-left: 18px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content_left .left_title_active {
  background-color: #8e0001;
  border-bottom: 1px solid #ffffff;
}
.content_left .left_title_active .left_title_icon {
  background-color: #a7051c;
}
.content_left .left_title_active .left_title_text {
  color: #ffffff;
}
.content_left .left_tabs {
  width: 298px;
  height: auto;
  display: flex;
  flex-direction: column;
}
.content_left .left_tabs .left_nav {
  width: 298px;
  height: auto;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #d7d7d7;
}
.content_left .left_tabs .left_nav .nav_content {
  width: 298px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.content_left .left_tabs .nav_content:last-child {
  border-bottom: none;
}
.content_left .left_tabs .nav_content .nav_text {
  width: 250px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #343434;
  text-align: left;
  margin-left: 18px;
}
.content_left .left_tabs .nav_content .nav_icon {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  color: #cbcbcb;
  text-align: left;
}
.content_left .left_tabs .nav_content.navActive {
  background-color: #b93132;
}
.content_left .left_tabs .nav_content.navActive .nav_text {
  color: #f7fffe;
}
.content_left .left_tabs .nav_content.navActive .nav_icon {
  color: #f7fffe;
}
.nav_slide {
  height: auto;
  transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.nav_slide .slide_nav {
  width: 280px;
  height: auto;
  margin-bottom: 6px;
}
.nav_slide .slide_nav:first-child {
  margin-top: 6px;
}
.nav_slide .slide_nav .slide_content {
  width: 280px;
  height: auto;
  background-color: #f1f1f1;
  margin-bottom: 6px;
}
.nav_slide .slide_nav .slide_content .slide_title {
  width: 280px;
  height: 37px;
  font-size: 16px;
  line-height: 37px;
  color: #333333;
  cursor: pointer;
  text-align: left;
  text-indent: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nav_slide .slide_nav .slide_content .slide_title.titleActive {
  color: #b93132;
}
.nav_slide .slide_nav .slide_content .slide_detail {
  width: 280px;
  height: auto;
}
.nav_slide .slide_nav .slide_content .slide_detail .detail_text {
  width: 280px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  color: #2e2e2e;
  text-align: left;
  text-indent: 42px;
  cursor: pointer;
}
.nav_slide .slide_nav .slide_content .slide_detail .detail_text.typeActive {
  color: #b93132;
}
.content_right {
  width: 884px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-left: 15px;
}
.right_top {
  width: 884px;
  height: auto;
  border: 1px solid #d7d7d7;
  background-color: #fefefe;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 0 29px;
}
.right_top .topic_type {
  width: 833px;
  height: 45px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 22px;
}
.right_top .topic_type .type_text {
  width: 833px;
  height: 43px;
  line-height: 43px;
  font-size: 18px;
  color: #030303;
  text-align: left;
}
.right_top .topic_type .type_line {
  width: 28px;
  height: 2px;
  background-color: #d7112c;
}
.right_top .topic_finish {
  width: 833px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 47px;
}
.right_top .topic_finish .finish_result {
  width: 833px;
  height: 64px;
  line-height: 64px;
  color: #474747;
  font-size: 14px;
}
.right_top .topic_finish .finish_btn {
  width: 107px;
  height: 33px;
  background-color: #5277d4;
  line-height: 33px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.right_top .topic_content {
  width: 833px;
  /* height: auto; */
  height: 260px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 47px;
}
.right_top .topic_content .topic_title {
  width: 833px;
  height: auto;
  margin-bottom: 22px;
  display: flex;
  flex-direction: row;
}
.right_top .topic_content .topic_title p {
  line-height: 22px;
  font-size: 14px;
  color: #3e3e3e;
  margin: 0 !important;
  padding: 0 !important;
}
.right_top .topic_content .topic_title p p {
  line-height: 22px;
  font-size: 14px;
  color: #3e3e3e;
  margin: 0 !important;
  padding: 0 !important;
}
.right_top .topic_content .topic_answers {
  width: 833px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}
.right_top .topic_content .topic_answers .answer_content {
  width: 833px;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
}
.right_top .topic_content .topic_answers .answer_content .answer_icon {
  width: 12px;
  height: 12px;
  margin: 12px 18px 0 8px;
  background-image: url("../assets/images/select.png");
}
.right_top
  .topic_content
  .topic_answers
  .answer_content
  .answer_icon.answerChecked {
  background-image: url("../assets/images/selected.png");
}
.right_top .topic_content .topic_answers .answer_content .answer_text {
  width: 795px;
  height: auto;
  font-size: 12px;
  color: #5c656a;
  line-height: 34px;
}
.right_top .topic_result {
  width: 783px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}
.right_top .topic_result .result_your {
  width: 783px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #2b3537;
  margin-bottom: 24px;
}
.right_top .topic_result .result_your span {
  color: #e1512e;
}
.right_top .topic_result .result_true {
  width: 783px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  color: #2b3537;
  margin-bottom: 24px;
}
.right_top .topic_result .result_analysis {
  width: 783px;
  height: auto;
  line-height: 24px;
  font-size: 14px;
  color: #2b3537;
  margin-bottom: 24px;
}
.right_top .topic_result .result_analysis p {
  margin: 0;
}
.right_top .topic_operation {
  width: 833px;
  height: 66px;
  border-top: 1px solid #e1e1e1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}
.right_top .topic_operation .operation_btn {
  width: 107px;
  height: 32px;
  margin-left: 14px;
  line-height: 32px;
  font-size: 14px;
  cursor: pointer;
}
.right_top .topic_operation .operation_left {
  width: 246px;
  height: 34px;
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.right_top .topic_operation .operation_left .pre_topic {
  border: 1px solid #e0e0e0;
  color: #61646b;
}
.right_top .topic_operation .next_topic {
  background-color: #ff8d31;
  border: 1px solid #ff8d31;
  color: #f8ffff;
}
.right_top .topic_operation .operation_right {
  width: 246px;
  height: 34px;
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.right_top .topic_operation .operation_right .operation_topic {
  background-color: #e2e2e2;
  border: 1px solid #d1d1d1;
  color: #404040;
}
.right_bottom {
  width: 884px;
  height: auto;
  border: 1px solid #d7d7d7;
  background-color: #fefefe;
  padding: 23px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.right_bottom .topic_number {
  width: 798px;
  width: 810px;
  max-height: 200px;
  padding-bottom: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 24px;
  margin-right: 5px;
  flex-wrap: wrap;
}
.right_bottom .topic_number .topic_index {
  width: 31px;
  height: 28px;
  background-color: #ffffff;
  border-radius: 1px;
  line-height: 28px;
  font-size: 12px;
  color: #264fcf;
  border: 1px solid #d3d3d3;
  margin-right: 6px;
  margin-bottom: 6px;
  cursor: pointer;
}
.right_bottom .topic_number .topic_index.finishText {
  color: #d80a3b;
  border: 1px solid #d80a3b;
}
.right_bottom .topic_number .topic_index.error {
  background-color: #cf302c;
  color: #ffffff;
  border: 1px solid #cf302c;
}
.right_bottom .topic_number .topic_index.right {
  background-color: #0db865;
  color: #ffffff;
  border: 1px solid #0db865;
}
.right_bottom .submit_topic {
  width: 36px;
  height: 100px;
  background-color: #ff8d31;
  color: #f8ffff;
  font-size: 16px;
  cursor: pointer;
  border-radius: 2px;
  text-align: center;
  line-height: 50px;
}
.main_content::-webkit-scrollbar {
  width: 8px;
}
.main_content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
  background: #e2e2e2;
}
.main_content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  background: #f1f1f1;
}
.main_content p {
  margin: 0;
  padding: 0;
}

/* 新增逻辑 */

.topic_index.cuowu {
  background: #8e0001 !important;
  color: #fff !important;
}
.topic_index.zhengque {
  background: #67c23a !important;
  color: #fff !important;
}
</style>
